import * as React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { mybswhTooltipMsg } from '../../helpers/data';

export default class PortalFilterPill extends React.Component {
    constructor(props) {
        super(props);
        this.state = { pillMybswhTooltipOpen: false };
    }

    togglePillMyBSWHTooltip = () => {
        this.setState({ pillMybswhTooltipOpen: !this.state.pillMybswhTooltipOpen });
    }

    render() {
        return (
            <span className="mybswh-perk-container" onClick={this.togglePillMyBSWHTooltip}>
                <img alt="MyBSWHealth" src="/images/mybswh-portal.png" /> portal <span className="icon-question" id="pillMybswhTooltip" />
                <UncontrolledTooltip placement="top" autohide={false} target="pillMybswhTooltip">
                    {mybswhTooltipMsg}
                </UncontrolledTooltip >
            </span>
        );
    }
}